module.exports = __webpack_public_path__ + "img/Table View.3617315d.svg";